import type { StorePageConfig } from '@/app/(football)/[team]/store/_context/types';

/**
 * FC Anyang Store Config (Placeholder)
 *
 * 스토어 기능이 아직 없는 팀을 위한 placeholder 설정
 * features.hasStore = false로 접근 제어
 */
export const fcanyangConfig: StorePageConfig = {
  titleSection: {
    title: '스토어',
    highlight: '오직 보라카드에서만!',
    description: '한정판 디지털 에디션을 만나보세요.',
  },
};
